<template>
    <a-modal title="流程调度"
             :width="1200"
             :visible="visible"
             :maskClosable="false"
             @ok="onSubmit"
             @cancel="onCancel"
             :confirmLoading="modalLoading"
             destroyOnClose>
        <template slot="footer">
            <a-button :disabled="!hasSelected" type="danger" @click="onBatchForceComplete">批量强制办结</a-button>
            <a-button v-if="procIns.state === 'C' && false" type="danger" @click="onResetActive">重设为在办状态</a-button>
        </template>
        <table width="100%" class="fx-form-view" style="table-layout:fixed;">
            <tr>
                <th colspan="1">流程标题</th>
                <td colspan="7"><a @click="onViewProcess(procIns)">{{procIns.title}}</a></td>
            </tr>
            <tr>
                <th colspan="1">文档类别</th>
                <td colspan="3">{{procIns.cateName}}</td>
                <th colspan="1">状态</th>
                <td colspan="3">
                    <a-tag v-if="procIns.state === 'C' || procIns.state === 'D'" color="green">{{procIns.extras.state}}</a-tag>
                    <a-tag v-else-if="procIns.state === 'T'" color="red">{{procIns.extras.state}}</a-tag>
                    <a-tag v-else>{{procIns.extras.state}}</a-tag>
                </td>
            </tr>
            <tr>
                <td colspan="8" style="text-align:center;padding:8px;"><a-icon type="warning" theme="twoTone" style="font-size:16px" />&nbsp;强制生成待办</td>
            </tr>
            <tr>
                <th colspan="1">生成路径节点</th>
                <td colspan="3">
                    <a-select placeholder="流程路径" @change="onChangeRoute" style="width:400px" allowClear>
                        <a-select-option v-for="(item, index) in procRoutes" :key="index" :value="item.id">{{item.name}} [{{item.fromActivity.name}}] -> [{{item.toActivity.name}}]</a-select-option>
                    </a-select>
                </td>
                <td colspan="4" rowspan="2" style="padding-left:40px">
                    <ol style="padding:0;color:#aaaaaa;margin:4px 0">
                        <li>已办结的情况下生成待办，会将流程转换为在办状态</li>
                        <li>其他 :-)</li>
                    </ol>
                    <a-button type="danger" @click="onCreateHandler">生成待办</a-button>
                </td>
            </tr>
            <tr>
                <th colspan="1">生成待办用户</th>
                <td colspan="3">
                    <user-selector @change="onChangeHandler" style="width:400px" />
                </td>
            </tr>
            <tr>
                <td colspan="8" style="text-align:center;padding:8px;"><a-icon type="warning" theme="twoTone" style="font-size:16px" />&nbsp;强制回收待办</td>
            </tr>
        </table>
        <a-table :columns="procActInsColumns" :dataSource="procActIns" :scroll="{ y: 240 }" bordered :pagination="false"
                 :rowKey="record => record.act_ins_id"
                 :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"  class="AAAA">
          <div slot="action" slot-scope="record"  >
            <a-button size="small" @click="onForceComplete(record.act_ins_id)">强制办结</a-button>
          </div>
        </a-table>
    </a-modal>
</template>

<script>
import qs from 'qs'
import UserSelector from '@/components/selector/UserSelector'

const procActInsColumns = [
  {
    title: '启动时间',
    dataIndex: 'create_date',
    width: 180
  },
  {
    title: '送件人',
    dataIndex: 'creator',
    width: 130
  },
  {
    title: '在办人',
    dataIndex: 'handler',
    width: 130
  },
  {
    title: '签收时间',
    dataIndex: 'sign_date',
    width: 180
  },
  {
    title: '任务',
    dataIndex: 'act_name',
    width: 180
  },
  {
    title: '备注',
    dataIndex: 'description',
    width: 180
  },
  {
    title: '操作',
    scopedSlots: { customRender: 'action' },
    width: 110
  }
]

export default {
  name: 'ProcessInstanceManage',
  components: {
    UserSelector
  },
  props: {
  },
  data () {
    return {
      visible: false,
      modalLoading: false,
      procIns: {
        extras: {
        }
      },
      procRoutes: [],
      procActInsColumns,
      selectedRowKeys: [],
      procActIns: [],
      formData: {
        procInsId: null,
        routeId: null,
        handlerId: null
      }
    }
  },
  mounted: function () {
  },
  computed: {
    hasSelected () {
      return this.selectedRowKeys.length > 0
    }
  },
  methods: {
    preManage (procInsId) {
      this.selectedRowKeys = []
      this.procActIns = []
      this.visible = true
      this.formData.procInsId = procInsId
      this.initData()
    },
    initData () {
      const that = this
      this.$http.get('/api/1/workflow/get_process_instance.json?procInsId=' + this.formData.procInsId).then(function (data) {
        that.procIns = data.result
        that.initRouteData()
        that.initActInsData()
      })
    },
    initRouteData () {
      const that = this
      this.$http.get('/api/1/workflow/get_process_routes.json?procId=' + this.procIns.procId).then(function (data) {
        that.procRoutes = data.result
      })
    },
    initActInsData () {
      const that = this
      this.$http.get('/api/1/workflow/get_act_ins_list.json?procInsId=' + this.procIns.id).then(function (data) {
        that.procActIns = data.result
        console.log(that.procActIns)
      })
    },
    onSubmit (event) {
      // this.$http.post('/api/1/workflow/design/save.json', qs.stringify(this.formData)).then(function (data) {
      // })
      this.visible = true
    },
    onCancel () {
      this.visible = false
    },
    onViewProcess (procIns) {
      let url = null
      let cateUrl = ''
      let cate = procIns.extras.cate
      if (cate != null) {
        cateUrl = cate.url
        console.log('cateUrl >' + cateUrl)
      }
      url = this.$_c + '#' + cateUrl + '?id=' + procIns.caseId
      window.open(url)
    },
    onSelectChange (selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    onResetActive () {
      const that = this
      this.$confirm({
        title: '确认要将流程重设为活动状态吗？\n设置完请记得生成一个待办给对应的人员继续处理',
        onOk () {
          that.$http.post('/api/1/workflow/update_process_instance_active.json', qs.stringify({ procInsId: that.formData.procInsId })).then(function (data) {
            that.initData()
          })
        }
      })
    },
    onChangeRoute (value) {
      this.formData.routeId = value
    },
    onChangeHandler (selectedIds, selectedNames) {
      this.formData.handlerId = selectedIds
    },
    onForceComplete (actInsId) {
      const that = this
      this.selectedRowKeys = []
      this.$confirm({
        title: '是否确认强制办结？',
        onOk () {
          that.forceComplete(actInsId)
        }
      })
    },
    onBatchForceComplete () {
      const that = this
      this.$confirm({
        title: '是否确认强制批量办结？',
        onOk () {
          that.forceComplete(that.selectedRowKeys.join(','))
        }
      })
    },
    forceComplete (ids) {
      const that = this
      this.$http.post('/api/1/workflow/force_act_ins_complete.json', qs.stringify({ ids: ids })).then(function (data) {
        that.$message.success(data.msg)
        that.selectedRowKeys = []
        that.initActInsData()
      })
    },
    onCreateHandler () {
      const that = this
      if (!this.formData.routeId || !this.formData.handlerId) {
        this.$message.warning('请选择路径和处理人')
        return
      }
      this.$http.post('/api/1/workflow/create_process_instance_handler.json', qs.stringify(this.formData)).then(function (data) {
        that.$message.success(data.msg)
        that.initActInsData()
      })
    }
  }
}
</script>

<style scoped>

</style>
